export default function RefreshClockIcon() {
    return (
        <svg
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M7.00001 4.08333V7L8.75001 8.75M0.583344 6.41667L1.75001 7.58333M1.75001 7.58333L2.91668 6.41667M1.75001 7.58333V7C1.75001 4.10051 4.10052 1.75 7.00001 1.75C8.55489 1.75 9.95191 2.42594 10.9132 3.5C10.9715 3.56518 11.0283 3.63183 11.0833 3.69988M11.0833 7.58333L12.25 6.41667M12.25 6.41667L13.4167 7.58333M12.25 6.41667V7C12.25 9.89952 9.89953 12.25 7.00001 12.25C5.35077 12.25 3.87915 11.4895 2.91668 10.3001"
                stroke="#5A5F6A"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
